import { cn } from '@/lib/utils/cn'
import { VENUE_AMENITY_CATALOG } from '@/lib/venue/venueProfileTypes'

/**
 * 편의시설 칩 다중 선택 — `VENUE_AMENITY_CATALOG`(8종, forward-only) 기반(설계 §2-1(d)·D4).
 *
 * 🚫 주차·샤워실·탈의실·대여 장비는 이 카탈로그에 없다 — 전용 필드가 정본이다(`#594` §4).
 */
export function VenueAmenityPicker({
  value,
  onChange,
}: {
  value: string[]
  onChange: (codes: string[]) => void
}) {
  function toggle(code: string) {
    if (value.includes(code)) {
      onChange(value.filter((item) => item !== code))
      return
    }
    onChange([...value, code])
  }

  return (
    <div role="group" aria-label="편의시설" className="flex flex-wrap gap-2">
      {VENUE_AMENITY_CATALOG.map((amenity) => {
        const selected = value.includes(amenity.code)
        return (
          <button
            key={amenity.code}
            type="button"
            aria-pressed={selected}
            onClick={() => {
              toggle(amenity.code)
            }}
            className={cn(
              'rounded-full border px-3 py-1.5 text-sm transition-colors',
              selected
                ? 'border-brand-500 bg-brand-50 text-brand-500'
                : 'border-slateish-300 bg-white text-slateish-600 hover:bg-slateish-100'
            )}
          >
            {amenity.label}
          </button>
        )
      })}
    </div>
  )
}
